<template>
  <div>
    <b v-if="version !== null" class="caption">
      <div>API v{{ version }} • FE v{{ appVersion }}</div>
    </b>
    <footer class="feedback-footer">
      <p class="feedback-footer__message" data-test-selector="feedback-footer-message">
        <span class="feedback-footer__message-bold">{{ $t('footer.messageBold') }}</span>
        {{ $t('footer.message') }}
      </p>
      <div class="feedback-footer--buttons">
        <common-button
          class="feedback-footer__btn"
          primary
          data-test-selector="take-survey-catering-button"
          @click="openCateringFeedbackForm"
        >
          {{ $t('footer.takeCateringSurveyAction') }}
        </common-button>
        <common-button
          class="feedback-footer__btn"
          primary
          data-test-selector="take-survey-button"
          @click="openFeedbackForm"
        >
          {{ $t('footer.takeSurveyAction') }}
        </common-button>
      </div>
    </footer>
  </div>
</template>

<script>
import CommonButton from '@/components/common/CommonButton';
import { FEEDBACK_FORM, FEEDBACK_CATERING_FORM, FOODIE_VERSION } from '@/constants';

export default {
  props: {
    version: String,
  },
  data() {
    return {
      appVersion: FOODIE_VERSION,
    };
  },
  components: {
    CommonButton,
  },
  methods: {
    openFeedbackForm() {
      window.open(FEEDBACK_FORM);
    },
    openCateringFeedbackForm() {
      window.open(FEEDBACK_CATERING_FORM);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';
.caption {
  font-size: small;
  position: fixed;
  bottom: 5rem;
  right: 20px;
  color: #d6d6d6;
  font-weight: 500;
}

.feedback-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 1rem;
  background-color: $footer-background-color;
  color: $black-color;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
  &__message {
    padding-right: 1rem;
    display: inline-block;
    &-bold {
      font-weight: bold;
    }
  }
  /deep/ &__btn {
    display: inline-block;
    margin-left: 5px;
    white-space: nowrap; // avoid button text breaking into 2 lines
    button.medium {
      height: 32px;
    }
  }

  .feedback-footer--buttons {
    display: grid;
    gap: 10px;
    grid-template-columns: 1fr 1fr;
  }
}
@media only screen and (max-width: 550px) {
  .feedback-footer {
    display: none; // hide for small screens
  }
  .caption {
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FeedbackFooter.vue